// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plots>*[data-v-4ee13896]{display:inline-block;width:50%;text-align:center}.plots label[data-v-4ee13896]{color:#484}.plots .off label[data-v-4ee13896]{color:#d00}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
